module.exports = __webpack_public_path__ + "img/total-de-referidos-vinculados-por-empleado.5a48e859.svg";